import { useMemo } from 'react';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { sortInstrumentsByOrderIndex } from '../helpers/sort/instruments';

export type IdentifiableInstrument = { instrumentId: string };

const useInstrumentSort = <T extends IdentifiableInstrument>(items: T[]) => {
  const instrumentsMapFromState = useAppSelector(
    (state) => state.capitalStructure?.values?.instrumentInformation?.instruments
  );

  const instrumentsMap = useMemo(() => {
    return instrumentsMapFromState ?? {};
  }, [instrumentsMapFromState]);

  const sortedItems = useMemo(() => {
    return items.slice().sort(sortInstrumentsByOrderIndex(instrumentsMap));
  }, [items, instrumentsMap]);

  return sortedItems;
};

export default useInstrumentSort;
